/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import type {
  BadRequestResponse,
  CreatePlatformCatalogVersionBody,
  DeleteSuccessDTO,
  ForbiddenResponse,
  GetAllPlatformCatalogVersionsParams,
  InternalServerErrorResponse,
  NotFoundResponse,
  PaginatedPlatformCatalogVersionListItemsDTO,
  PlatformCatalogVersionDTO,
  PlatformCatalogVersionUpdateDTO,
  UnauthorizedResponse,
} from "../../model";
import { customFetchInstance } from "../../../custom-fetch-instance";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Returns a paginated list of platform catalog versions for a specific platform catalog.
 * @summary Returns a paginated list of platform catalog versions
 */
export type getAllPlatformCatalogVersionsResponse = {
  data: PaginatedPlatformCatalogVersionListItemsDTO;
  status: number;
};

export const getGetAllPlatformCatalogVersionsUrl = (
  supplierId: string,
  platformCatalogId: string,
  params?: GetAllPlatformCatalogVersionsParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs/${platformCatalogId}/platform-catalog-versions?${normalizedParams.toString()}`
    : `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs/${platformCatalogId}/platform-catalog-versions`;
};

export const getAllPlatformCatalogVersions = async (
  supplierId: string,
  platformCatalogId: string,
  params?: GetAllPlatformCatalogVersionsParams,
  options?: RequestInit
): Promise<getAllPlatformCatalogVersionsResponse> => {
  return customFetchInstance<Promise<getAllPlatformCatalogVersionsResponse>>(
    getGetAllPlatformCatalogVersionsUrl(supplierId, platformCatalogId, params),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetAllPlatformCatalogVersionsQueryKey = (
  supplierId: string,
  platformCatalogId: string,
  params?: GetAllPlatformCatalogVersionsParams
) => {
  return [
    `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs/${platformCatalogId}/platform-catalog-versions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAllPlatformCatalogVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  params?: GetAllPlatformCatalogVersionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAllPlatformCatalogVersionsQueryKey(
      supplierId,
      platformCatalogId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>
  > = ({ signal }) =>
    getAllPlatformCatalogVersions(supplierId, platformCatalogId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(supplierId && platformCatalogId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllPlatformCatalogVersionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>
>;
export type GetAllPlatformCatalogVersionsQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetAllPlatformCatalogVersions<
  TData = Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  params: undefined | GetAllPlatformCatalogVersionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetAllPlatformCatalogVersions<
  TData = Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  params?: GetAllPlatformCatalogVersionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetAllPlatformCatalogVersions<
  TData = Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  params?: GetAllPlatformCatalogVersionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a paginated list of platform catalog versions
 */

export function useGetAllPlatformCatalogVersions<
  TData = Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  params?: GetAllPlatformCatalogVersionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAllPlatformCatalogVersionsQueryOptions(
    supplierId,
    platformCatalogId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAllPlatformCatalogVersionsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  params?: GetAllPlatformCatalogVersionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAllPlatformCatalogVersionsQueryKey(
      supplierId,
      platformCatalogId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>
  > = ({ signal }) =>
    getAllPlatformCatalogVersions(supplierId, platformCatalogId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(supplierId && platformCatalogId),
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllPlatformCatalogVersionsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>
>;
export type GetAllPlatformCatalogVersionsSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetAllPlatformCatalogVersionsSuspense<
  TData = Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  params: undefined | GetAllPlatformCatalogVersionsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetAllPlatformCatalogVersionsSuspense<
  TData = Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  params?: GetAllPlatformCatalogVersionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetAllPlatformCatalogVersionsSuspense<
  TData = Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  params?: GetAllPlatformCatalogVersionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a paginated list of platform catalog versions
 */

export function useGetAllPlatformCatalogVersionsSuspense<
  TData = Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  params?: GetAllPlatformCatalogVersionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllPlatformCatalogVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAllPlatformCatalogVersionsSuspenseQueryOptions(
    supplierId,
    platformCatalogId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Allows the upload of a new platform catalog, thus creating a new platform catalog version.
 * @summary Creates a new platform catalog version
 */
export type createPlatformCatalogVersionResponse = {
  data: PlatformCatalogVersionDTO;
  status: number;
};

export const getCreatePlatformCatalogVersionUrl = (
  supplierId: string,
  platformCatalogId: string
) => {
  return `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs/${platformCatalogId}/platform-catalog-versions`;
};

export const createPlatformCatalogVersion = async (
  supplierId: string,
  platformCatalogId: string,
  createPlatformCatalogVersionBody: CreatePlatformCatalogVersionBody,
  options?: RequestInit
): Promise<createPlatformCatalogVersionResponse> => {
  const formData = new FormData();
  formData.append(
    "platformCatalogVersionCreateDTO",
    JSON.stringify(
      createPlatformCatalogVersionBody.platformCatalogVersionCreateDTO
    )
  );
  formData.append("catalog", createPlatformCatalogVersionBody.catalog);
  if (createPlatformCatalogVersionBody.relationTable !== undefined) {
    formData.append(
      "relationTable",
      createPlatformCatalogVersionBody.relationTable
    );
  }

  return customFetchInstance<Promise<createPlatformCatalogVersionResponse>>(
    getCreatePlatformCatalogVersionUrl(supplierId, platformCatalogId),
    {
      ...options,
      method: "POST",
      body: formData,
    }
  );
};

export const getCreatePlatformCatalogVersionMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPlatformCatalogVersion>>,
    TError,
    {
      supplierId: string;
      platformCatalogId: string;
      data: CreatePlatformCatalogVersionBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPlatformCatalogVersion>>,
  TError,
  {
    supplierId: string;
    platformCatalogId: string;
    data: CreatePlatformCatalogVersionBody;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPlatformCatalogVersion>>,
    {
      supplierId: string;
      platformCatalogId: string;
      data: CreatePlatformCatalogVersionBody;
    }
  > = (props) => {
    const { supplierId, platformCatalogId, data } = props ?? {};

    return createPlatformCatalogVersion(
      supplierId,
      platformCatalogId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePlatformCatalogVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPlatformCatalogVersion>>
>;
export type CreatePlatformCatalogVersionMutationBody =
  CreatePlatformCatalogVersionBody;
export type CreatePlatformCatalogVersionMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Creates a new platform catalog version
 */
export const useCreatePlatformCatalogVersion = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPlatformCatalogVersion>>,
    TError,
    {
      supplierId: string;
      platformCatalogId: string;
      data: CreatePlatformCatalogVersionBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPlatformCatalogVersion>>,
  TError,
  {
    supplierId: string;
    platformCatalogId: string;
    data: CreatePlatformCatalogVersionBody;
  },
  TContext
> => {
  const mutationOptions =
    getCreatePlatformCatalogVersionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Retrieval of a specific platform catalog's version
 * @summary Returns a specific platform catalog's version
 */
export type getPlatformCatalogVersionByIdResponse = {
  data: PlatformCatalogVersionDTO;
  status: number;
};

export const getGetPlatformCatalogVersionByIdUrl = (
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string
) => {
  return `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs/${platformCatalogId}/platform-catalog-versions/${platformCatalogVersionId}`;
};

export const getPlatformCatalogVersionById = async (
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: RequestInit
): Promise<getPlatformCatalogVersionByIdResponse> => {
  return customFetchInstance<Promise<getPlatformCatalogVersionByIdResponse>>(
    getGetPlatformCatalogVersionByIdUrl(
      supplierId,
      platformCatalogId,
      platformCatalogVersionId
    ),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetPlatformCatalogVersionByIdQueryKey = (
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string
) => {
  return [
    `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs/${platformCatalogId}/platform-catalog-versions/${platformCatalogVersionId}`,
  ] as const;
};

export const getGetPlatformCatalogVersionByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPlatformCatalogVersionByIdQueryKey(
      supplierId,
      platformCatalogId,
      platformCatalogVersionId
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformCatalogVersionById>>
  > = ({ signal }) =>
    getPlatformCatalogVersionById(
      supplierId,
      platformCatalogId,
      platformCatalogVersionId,
      { signal, ...requestOptions }
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(supplierId && platformCatalogId && platformCatalogVersionId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformCatalogVersionByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformCatalogVersionById>>
>;
export type GetPlatformCatalogVersionByIdQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetPlatformCatalogVersionById<
  TData = Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformCatalogVersionById<
  TData = Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformCatalogVersionById<
  TData = Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a specific platform catalog's version
 */

export function useGetPlatformCatalogVersionById<
  TData = Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlatformCatalogVersionByIdQueryOptions(
    supplierId,
    platformCatalogId,
    platformCatalogVersionId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPlatformCatalogVersionByIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPlatformCatalogVersionByIdQueryKey(
      supplierId,
      platformCatalogId,
      platformCatalogVersionId
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformCatalogVersionById>>
  > = ({ signal }) =>
    getPlatformCatalogVersionById(
      supplierId,
      platformCatalogId,
      platformCatalogVersionId,
      { signal, ...requestOptions }
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(supplierId && platformCatalogId && platformCatalogVersionId),
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformCatalogVersionByIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformCatalogVersionById>>
>;
export type GetPlatformCatalogVersionByIdSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetPlatformCatalogVersionByIdSuspense<
  TData = Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformCatalogVersionByIdSuspense<
  TData = Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformCatalogVersionByIdSuspense<
  TData = Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a specific platform catalog's version
 */

export function useGetPlatformCatalogVersionByIdSuspense<
  TData = Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogVersionById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlatformCatalogVersionByIdSuspenseQueryOptions(
    supplierId,
    platformCatalogId,
    platformCatalogVersionId,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Allows to update a platform catalog version.
 * @summary Updates an existing platform catalog version
 */
export type updatePlatformCatalogVersionResponse = {
  data: PlatformCatalogVersionDTO;
  status: number;
};

export const getUpdatePlatformCatalogVersionUrl = (
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string
) => {
  return `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs/${platformCatalogId}/platform-catalog-versions/${platformCatalogVersionId}`;
};

export const updatePlatformCatalogVersion = async (
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  platformCatalogVersionUpdateDTO: PlatformCatalogVersionUpdateDTO,
  options?: RequestInit
): Promise<updatePlatformCatalogVersionResponse> => {
  return customFetchInstance<Promise<updatePlatformCatalogVersionResponse>>(
    getUpdatePlatformCatalogVersionUrl(
      supplierId,
      platformCatalogId,
      platformCatalogVersionId
    ),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(platformCatalogVersionUpdateDTO),
    }
  );
};

export const getUpdatePlatformCatalogVersionMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlatformCatalogVersion>>,
    TError,
    {
      supplierId: string;
      platformCatalogId: string;
      platformCatalogVersionId: string;
      data: PlatformCatalogVersionUpdateDTO;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePlatformCatalogVersion>>,
  TError,
  {
    supplierId: string;
    platformCatalogId: string;
    platformCatalogVersionId: string;
    data: PlatformCatalogVersionUpdateDTO;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePlatformCatalogVersion>>,
    {
      supplierId: string;
      platformCatalogId: string;
      platformCatalogVersionId: string;
      data: PlatformCatalogVersionUpdateDTO;
    }
  > = (props) => {
    const { supplierId, platformCatalogId, platformCatalogVersionId, data } =
      props ?? {};

    return updatePlatformCatalogVersion(
      supplierId,
      platformCatalogId,
      platformCatalogVersionId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePlatformCatalogVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePlatformCatalogVersion>>
>;
export type UpdatePlatformCatalogVersionMutationBody =
  PlatformCatalogVersionUpdateDTO;
export type UpdatePlatformCatalogVersionMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Updates an existing platform catalog version
 */
export const useUpdatePlatformCatalogVersion = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlatformCatalogVersion>>,
    TError,
    {
      supplierId: string;
      platformCatalogId: string;
      platformCatalogVersionId: string;
      data: PlatformCatalogVersionUpdateDTO;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePlatformCatalogVersion>>,
  TError,
  {
    supplierId: string;
    platformCatalogId: string;
    platformCatalogVersionId: string;
    data: PlatformCatalogVersionUpdateDTO;
  },
  TContext
> => {
  const mutationOptions =
    getUpdatePlatformCatalogVersionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Allows the deletion of a platform catalog version.
 * @summary Deletes a specific platform catalog version
 */
export type deletePlatformCatalogVersionByIdResponse = {
  data: DeleteSuccessDTO;
  status: number;
};

export const getDeletePlatformCatalogVersionByIdUrl = (
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string
) => {
  return `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs/${platformCatalogId}/platform-catalog-versions/${platformCatalogVersionId}`;
};

export const deletePlatformCatalogVersionById = async (
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: RequestInit
): Promise<deletePlatformCatalogVersionByIdResponse> => {
  return customFetchInstance<Promise<deletePlatformCatalogVersionByIdResponse>>(
    getDeletePlatformCatalogVersionByIdUrl(
      supplierId,
      platformCatalogId,
      platformCatalogVersionId
    ),
    {
      ...options,
      method: "DELETE",
    }
  );
};

export const getDeletePlatformCatalogVersionByIdMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePlatformCatalogVersionById>>,
    TError,
    {
      supplierId: string;
      platformCatalogId: string;
      platformCatalogVersionId: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePlatformCatalogVersionById>>,
  TError,
  {
    supplierId: string;
    platformCatalogId: string;
    platformCatalogVersionId: string;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePlatformCatalogVersionById>>,
    {
      supplierId: string;
      platformCatalogId: string;
      platformCatalogVersionId: string;
    }
  > = (props) => {
    const { supplierId, platformCatalogId, platformCatalogVersionId } =
      props ?? {};

    return deletePlatformCatalogVersionById(
      supplierId,
      platformCatalogId,
      platformCatalogVersionId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePlatformCatalogVersionByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePlatformCatalogVersionById>>
>;

export type DeletePlatformCatalogVersionByIdMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Deletes a specific platform catalog version
 */
export const useDeletePlatformCatalogVersionById = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePlatformCatalogVersionById>>,
    TError,
    {
      supplierId: string;
      platformCatalogId: string;
      platformCatalogVersionId: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePlatformCatalogVersionById>>,
  TError,
  {
    supplierId: string;
    platformCatalogId: string;
    platformCatalogVersionId: string;
  },
  TContext
> => {
  const mutationOptions =
    getDeletePlatformCatalogVersionByIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Returns a `.zip` file containing the catalog and, if present, relationship table XML files. 
The catalog will be saved in a file with the name `catalog.xml` the relationship table in a file with the name `relationship-table.xml`.

 * @summary Returns a specific platform catalog's version
 */
export type downloadPlatformCatalogVersionByIdResponse = {
  data: Blob;
  status: number;
};

export const getDownloadPlatformCatalogVersionByIdUrl = (
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string
) => {
  return `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs/${platformCatalogId}/platform-catalog-versions/${platformCatalogVersionId}/download`;
};

export const downloadPlatformCatalogVersionById = async (
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: RequestInit
): Promise<downloadPlatformCatalogVersionByIdResponse> => {
  return customFetchInstance<
    Promise<downloadPlatformCatalogVersionByIdResponse>
  >(
    getDownloadPlatformCatalogVersionByIdUrl(
      supplierId,
      platformCatalogId,
      platformCatalogVersionId
    ),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getDownloadPlatformCatalogVersionByIdQueryKey = (
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string
) => {
  return [
    `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs/${platformCatalogId}/platform-catalog-versions/${platformCatalogVersionId}/download`,
  ] as const;
};

export const getDownloadPlatformCatalogVersionByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadPlatformCatalogVersionByIdQueryKey(
      supplierId,
      platformCatalogId,
      platformCatalogVersionId
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>
  > = ({ signal }) =>
    downloadPlatformCatalogVersionById(
      supplierId,
      platformCatalogId,
      platformCatalogVersionId,
      { signal, ...requestOptions }
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(supplierId && platformCatalogId && platformCatalogVersionId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadPlatformCatalogVersionByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>
>;
export type DownloadPlatformCatalogVersionByIdQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useDownloadPlatformCatalogVersionById<
  TData = Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDownloadPlatformCatalogVersionById<
  TData = Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDownloadPlatformCatalogVersionById<
  TData = Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a specific platform catalog's version
 */

export function useDownloadPlatformCatalogVersionById<
  TData = Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadPlatformCatalogVersionByIdQueryOptions(
    supplierId,
    platformCatalogId,
    platformCatalogVersionId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDownloadPlatformCatalogVersionByIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadPlatformCatalogVersionByIdQueryKey(
      supplierId,
      platformCatalogId,
      platformCatalogVersionId
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>
  > = ({ signal }) =>
    downloadPlatformCatalogVersionById(
      supplierId,
      platformCatalogId,
      platformCatalogVersionId,
      { signal, ...requestOptions }
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(supplierId && platformCatalogId && platformCatalogVersionId),
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadPlatformCatalogVersionByIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>
>;
export type DownloadPlatformCatalogVersionByIdSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useDownloadPlatformCatalogVersionByIdSuspense<
  TData = Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDownloadPlatformCatalogVersionByIdSuspense<
  TData = Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDownloadPlatformCatalogVersionByIdSuspense<
  TData = Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a specific platform catalog's version
 */

export function useDownloadPlatformCatalogVersionByIdSuspense<
  TData = Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  platformCatalogVersionId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof downloadPlatformCatalogVersionById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getDownloadPlatformCatalogVersionByIdSuspenseQueryOptions(
      supplierId,
      platformCatalogId,
      platformCatalogVersionId,
      options
    );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
